import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'usimweb-checkbox',
    template: `
    <mat-checkbox [ngStyle]="{ 'color': checked ? 'black' : color }" [(ngModel)]="checked" (change)="change()">
      <span [ngStyle]="{ color: labelColor }">{{ label }}</span>
    </mat-checkbox>
  `,
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent {
  /**
   * Optional text?
   */
  @Input() label!: string;
  /**
   * Option to to toggle the button ?
   */
  @Input() checked!: boolean;
  /**
   * App specific colors ?
   */
  @Input() color: string = '#f49602';

  @Input() labelColor: string = 'black';

  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() checkedChange = new EventEmitter<any>();

  change() {
    this.checkedChange.emit(this.checked);
    this.onChange.emit(this.checked);
  }
}
